import { CandlePoint } from "../../candle.types";

export function normalizeCandle(candle: CandlePoint): CandlePoint {
  return {
    ...candle,
    startTime: Number(candle.startTime),
  };
}

export function sortCandlesAsc(candles: CandlePoint[]): CandlePoint[] {
  return [...candles].sort((a, b) => a.startTime - b.startTime);
}

export function dedupeCandles(candles: CandlePoint[]): CandlePoint[] {
  const map = new Map<number, CandlePoint>();
  candles.forEach((candle) => {
    map.set(candle.startTime, normalizeCandle(candle));
  });
  return sortCandlesAsc(Array.from(map.values()));
}

export function throwHttpError(response: Response, exchange: string): never {
  if (response.status === 404) {
    throw new Error(`${exchange}: token not available`);
  }
  if (response.status === 429) {
    throw new Error(`${exchange}: rate limit exceeded`);
  }
  throw new Error("Price chart is temporarily unavailable");
}

